module.exports = __webpack_public_path__ + "static/media/boat-img-31.3faaeb92.jpg";